import { FC } from 'react';
import useMassActions from './MassAction/useMassActions';
import { Trans } from 'react-i18next';
import styles from './style.module.scss';
import classNames from 'classnames';
import Link from '@components/Link';
import Sticky from 'react-stickynode';
// import PlayIcon from '@static/img/icons/play.svg';
// import RestartIcon from '@static/img/icons/restart.svg';
// import StopIcon from '@static/img/icons/stop.svg';

const ListMassActions: FC = () => {
    const { show: showMassAction, linkIds } = useMassActions();
    if (!showMassAction || !linkIds) return null;
    return (
        <Sticky enabled={true} innerZ={999}>
            <div className={styles.service_mass_action}>
                <div className="row">
                    <div className={classNames(`col-lg-3`, styles.title)}>
                        <span>
                            <Trans i18nKey="massAction.title" ns="uiServicesMain">
                                Masiniai veiksmai:
                            </Trans>
                        </span>
                    </div>
                    <div className={classNames(`col-lg-9`, styles.mass_action_buttons)}>
                        <div className={classNames(`btn-group d-flex`, styles.btn_group)}>
                            <div className='col-lg-9'/>
                            {/* <button type="button" className={classNames(`btn btn-link`, styles.btn)}>
                            <PlayIcon />
                                <Trans i18nKey="massAction.start" ns="uiServicesMain">
                                    Paleisti
                                </Trans>
                            </button>
                            <button type="button" className={classNames(`btn btn-link`, styles.btn)}>
                            <RestartIcon />
                                <Trans i18nKey="massAction.restart" ns="uiServicesMain">
                                    Perkrauti
                                </Trans>
                            </button>
                            <button type="button" className={classNames(`btn btn-link`, styles.btn)}>
                            <StopIcon />
                                <Trans i18nKey="massAction.stop" ns="uiServicesMain">
                                    Stabdyti
                                </Trans>
                            </button> */}
                            <Link href="ui_services_mass_renew" params={{ ids: linkIds }}>
                                <a
                                    className={classNames(
                                        'btn btn-outline-primary',
                                        styles.btn_renew
                                    )}
                                >
                                    <Trans i18nKey="button.renew" ns="uiServicesMain">
                                        Pratesti
                                    </Trans>
                                </a>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </Sticky>
    );
};

export default ListMassActions;
